<template>
    <div>
      <div class="drawer-card card-shadow">
        <div class="form-group w-100 mb_20 mt_5">
            <label class="label-input">{{StringLanguage.currentPassword}}</label>
            <input v-model="oPassword.current_password" type="password" class="form-control form-control-default bg-white valid color-4" placeholder=""/>
        </div>

        <div class="form-group w-100 mb_20">
            <label class="label-input">{{StringLanguage.newPassword}}</label>
            <input v-model="oPassword.password" type="password" class="form-control form-control-default bg-white valid color-4" placeholder=""/>
        </div>

        <div class="form-group w-100 mb_5">
            <label class="label-input">{{StringLanguage.repeatNewPassword}}</label>
            <input v-model="oPassword.password2" type="password" class="form-control form-control-default bg-white valid color-4" placeholder=""/>
        </div>
      </div>

      <div class="px_15">
        <button @click="save" type="button" class="w-100 btn_2 btn_sm btn-primary py_15 px_0 mobile-btn">
          {{StringLanguage.change}}
        </button>
      </div>
    </div>
</template>
<script>
import {TheMask} from 'vue-the-mask'
import AccountAPI from '@/api/account'
import Password from '@/plugins/core/schema/configurations/account/Password'
import { getXUserKey } from '@/plugins/account'
import Vue from 'vue'

export default {
  data () {
    return {
      oPassword: new Password()
    }
  },
  methods: {
    save: function(){
      let self = this
      AccountAPI.updatePassword({
        ...self.oPassword, login_hash: getXUserKey()
      }).then((response) => {
        self.set(response)
      })
    },
    set(response) {
      if(response.getErrors([]).length > 0) {
          alert(response.getErrors([])[0])
          return false
      } else {
          Vue.set(this, 'oPassword', new Password());
          alert(StringLanguage.savePasswordChangeSuccess);
      }
    }
  },
  components: {
    TheMask
  }
}

</script>